module.exports = __webpack_public_path__ + "media/images/modules/root_on_talkport/Image_pctop-3096579eb406ede371866bcd3897b69a.png";